<template>
    <div>
        <kgr-offering-stat-overview
            :offering="offering"
            :appointments="appointmentList"
            :booking-from="bookingFrom"
            :booking-to="bookingTo"
            :is-training="false"
        />
        <kgr-accordion>
            <div
                v-for="(appointment, index) in appointmentList"
                :key="appointment.key"
                @click="toggleItem(appointment, index)"
            >
                <kgr-generic-appointment-accordion-item
                    :appointment-prop="appointment"
                    :instructors="instructors"
                    :bookings="bookings"
                    :wait-list="waitList"
                    :offering="offering"
                    :club-id="clubId"
                    :index="index"
                    :error="error"
                    :pending="pending"
                    :active="index === activeIndex"
                    :table-columns="tableColumns"
                    :user-id="userId"
                    :search-open-index="searchOpenIndex"
                    @updateAppointment="updateAppointment(index, $event)"
                    @updateBookings="getBookings($event)"
                    @updateWaitList="getWaitList($event)"
                    @openSearch="searchOpenIndex = $event"
                    @update:offeringBooking="getBookings($event)"
                />
                <div class="kgr-row"></div>
            </div>
        </kgr-accordion>
    </div>
</template>

<script>
import Accordion from '../../common/accordion/Accordion.vue';
import Error from '../../../js/model/Error.js';
import GenericAppointmentAccordionItem from './GenericAppointmentAccordionItem.vue';
import Offering from '../../../js/dto/offering/Offering.js'
import OfferingBookingRepository from '../../../js/repository/club/offering/OfferingBookingRepository.js';
import OfferingStatsOverview from './OfferingStatsOverview.vue';
import TableColumnRepository from '../../../js/repository/club/offering/TableColumnRepository.js';
import WaitListRepository from '../../../js/repository/WaitListRepository.js';
import moment from 'moment';

export default {
    name: 'KgrGenericAppointmentAccordion',
    components: {
        'kgr-accordion': Accordion,
        'kgr-offering-stat-overview': OfferingStatsOverview,
        'kgr-generic-appointment-accordion-item': GenericAppointmentAccordionItem,
    },
    props: {
        appointments: {
            type: Array,
            required: true,
        },
        instructors: {
            type: Array,
            required: true,
        },
        offering: {
            type: Offering,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        bookingFrom: {
            type: String,
            required: true,
        },
        bookingTo: {
            type: String,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: null,
            pendingBookings: false,
            pendingWaitList: false,
            appointmentList: this.appointments,
            bookings: [],
            waitList: [],
            tableColumns: [],
            searchOpenIndex: null,
        }
    },
    computed: {
        pending() {
            return this.pendingBookings || this.pendingWaitList;
        },
    },
    created() {
        this.loadTableColumns();
    },
    methods: {
        toggleItem(appointment, index) {
            if (this.activeIndex !== index) {
                this.getBookings(appointment);
                this.getWaitList(appointment);
                this.activeIndex = index;
            }
        },
        updateAppointment(index, appointment){
            this.appointmentList[index] = appointment;
        },
        getBookings(appointment) {
            this.bookings = [];
            this.pendingBookings = true;
            OfferingBookingRepository.findAll(appointment.appointmentSeries.id, moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'), moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'))
                .then(bookings => this.bookings = bookings)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pendingBookings = false);
        },
        getWaitList(appointment) {
            this.waitList = [];
            this.pendingWaitList = true;
            WaitListRepository.findAll(appointment.appointmentSeries.id, moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'), moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'))
                .then(waitList => this.waitList = waitList)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pendingWaitList = false);
        },
        loadTableColumns() {
            TableColumnRepository.findByClub(this.clubId, this.offering.id)
                .then(response => this.tableColumns = response)
                .catch(() => this.$notify.error('error.loadingData'));
        },
    },
}
</script>

